import React from "react";

import VeneerLoadingIndicator from "veneer/LoadingIndicator";
import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

interface LoadingIndicatorProps {
  title?: string;
  width?: number | string;
}

export default function LoadingIndicator({
  title,
  width,
}: LoadingIndicatorProps) {
  return (
    <Stack
      dataTestId="cortex-loading-indicator"
      justifyContent="center"
      py={2}
      width="100%"
    >
      <Stack alignItems="center" direction="column" spacing={2}>
        <VeneerLoadingIndicator width={width} />
        {title && (
          <Typography color={Colors.gray1000} variant="h5">
            {title}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
